// localStorage.activeAppId e' solo una cache client-side (scritta da login.vue/portfolio.vue):
// se manca (primo accesso su un browser/dispositivo diverso, storage svuotato, ecc.) chi legge
// quella chiave senza fallback tratta l'utente come "senza app attiva", anche quando userData
// (il cookie autorevole lato server) la conosce benissimo. Bug reale confermato il 2026-10-20 in
// resources/ts/navigation/vertical/client.ts (sidebar vuota) e resources/ts/plugins/1.router/guards.ts
// (blocco totale della navigazione su /apps/*, /settings/*, /dashboards/*).
//
// Importante: userData.allowed_apps NON e' mai presente nel cookie - setUserDataCookie() in
// resources/ts/utils/api.ts lo rimuove deliberatamente prima di scriverlo (puo' superare il limite
// di ~4KB di un cookie per tenant con molte app, vedi commento li'). Il fallback qui usa solo
// default_app_id/tenant.app_id, che restano sempre nel cookie.
export const resolveActiveAppId = (userData?: any): string | null => {
  const id = userData?.default_app_id ?? userData?.tenant?.app_id ?? null

  return id != null && id !== '' ? String(id) : null
}

// Migliore sforzo per un nome da mostrare quando la cache locale non ce l'ha: userData.tenant.name
// (AuthController::toUserData()) e' gia' risolto come store_settings.store_name, altrimenti il nome
// dell'app attiva, altrimenti il nome del tenant - il proxy piu' vicino disponibile nel cookie
// all'effettivo nome dell'app attiva, dato che allowed_apps non c'e'.
export const resolveActiveAppName = (userData?: any): string | null => {
  const name = userData?.tenant?.name

  return typeof name === 'string' && name.trim() !== '' ? name : null
}
